/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$(document).ready(function(){
    resizeContent();

    $(window).resize(function() {
        resizeContent();
    });

});

function resizeContent() {
    $window = $(window); 
  var height = $window.height();
  //console.log(height);
  var mheight = 170;
  $('.desktop-video video').height(height - mheight);
 
  
}



$(document).ready(function(){
  $("select option").mouseenter(function(){
    $("select option").css("background-color", "#000000");
  });
  $("select option").mouseleave(function(){
    $("select option").css("background-color", "lightgray");
  });
  
  $('.our-story-page').parents('body').addClass('our-story-template');



setInterval(function () {
    if ($('.NewsletterPopup').attr('aria-hidden') === "false") {
        $('body').addClass('cstm-overlay');
    } else {
        $('body').removeClass('cstm-overlay');
    }
}, 10); 

  
});
